import { Navigate } from 'react-router-dom';
import { useWorkspace } from '../context/WorkspaceContext';

const PERM_MAP = {
  manage_staff: 'manage_staff',
  view_properties: 'view_properties',
  manage_bookings: 'manage_bookings',
  view_analytics: 'view_analytics',
  view_activity: 'view_activity',
  view_notifications: 'view_notifications',
};

const WorkspacePermissionRoute = ({ permission, children }) => {
  const { permissions, loading } = useWorkspace();

  if (!permission) return children;

  if (loading) {
    return <p className="workspace-loading">Loading...</p>;
  }

  const key = PERM_MAP[permission] || permission;
  if (permissions[key]) return children;

  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const role = String(user?.role || '');
    if (role === 'company_admin' && (key === 'manage_staff' || key === 'manage_invite')) {
      return children;
    }
  } catch {
    /* ignore */
  }

  return <Navigate to="/workspace" replace />;
};

export default WorkspacePermissionRoute;
